import {SEARCH} from "../constant";

export const searchAction = (data) => {
    return {type:SEARCH, data};
}

